import { memo, useEffect, useState, useRef } from "react"
import ProductList from "@/components/product/list"
import ProductService from "@/services/product"
import { Box, Flex, Stack, Text } from "@chakra-ui/react"
import { useNavigate, useParams } from "react-router";
import { HStack, Input, Center, AspectRatio, Button, Image, Table, Container, Wrap, Float, Drawer, CloseButton, Skeleton, SkeletonText, VStack } from "@chakra-ui/react"
import { LuSearch, LuShoppingCart, LuMessageCircle } from "react-icons/lu"
import { Heading } from "@chakra-ui/react"



import { Field } from "@/components/ui/field"
import Slider from "react-slick";
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"
import { useAuth } from "contexts/auth"
import { PinInput } from "@/components/ui/pin-input"
import _ from "lodash"
import { useStore } from "contexts/store";
import BottomSheet from "components/bottom-sheet"
const OtpInput = ({ open, onOpenChange, onOk }) => {


    const pinInput = useRef();

    const { copyText } = useApp();
    const { store } = useStore();


    const onOtpOk = () => {
        onOk(pinInput.current.value);
        onOpenChange(false);
    }


    return (
        <div>
            <BottomSheet open={open} onOpenChange={(e) => onOpenChange(e.open)} title="Xác nhận otp">
                <VStack>
                    <Text>
                        Mã xác nhận đã được gửi tới bạn
                    </Text>
                    <Text>
                        Mã xác nhận
                    </Text>
                    <PinInput ref={pinInput} otp />
                    <Button onClick={onOtpOk}>Xác nhận</Button>
                </VStack>

            </BottomSheet>



        </div>
    )
}

export default memo(OtpInput)